<script>
export default {
  name: "BreadcrumbComponent",
  props: {
    links: {
      type: Array,
      required: true,
      validator(value) {
        return value.every(
            (item) => typeof item === "object" && "text" in item && "href" in item
        );
      },
    },
  },
};
</script>

<template>
  <div class="breadcrumb-component">
    <template v-for="(link, index) in links" :key="index">
      <a
          :href="link.href"
          :class="{
          'breadcrumb-component-main': index === 0,
          'breadcrumb-component-navigation-page': index > 0 && index < links.length - 1,
          'breadcrumb-component-navigation-last': index === links.length - 1,
        }"
      >
        {{ link.text }}
      </a>
      <div
          v-if="index < links.length - 1"
          class="breadcrumb-component-arrow"
      >
        &nbsp;&nbsp;>&nbsp;&nbsp;
      </div>
    </template>
  </div>
</template>

<style scoped>
.breadcrumb-component {
  display: flex;
  padding-top: 22px;
  padding-bottom: 14px;
  align-items: center;
}

.breadcrumb-component a {
  text-decoration: none;
}

.breadcrumb-component-main {
  font-weight: 400;
  font-size: 12px;
  color: #23282C;
}

.breadcrumb-component-arrow {
  color: #575A60;
  font-size: 12px;
}

.breadcrumb-component-navigation-page {
  font-weight: 400;
  font-size: 14px;
  color: #23282C;
}

.breadcrumb-component-navigation-last {
  font-weight: 400;
  font-size: 14px;
  color: #7F8287;
}

.breadcrumb-component a:hover {
  color: red;
}
</style>
